import {
  BenchmarkChecklist,
  UnitChecklist,
  WeeklyChecklist,
} from './../../../types/schema-generated-types';
import { QueryResult, useQuery, OperationVariables } from '@apollo/client';
import { StoreTypename } from 'types';
import GET_CHECKLIST from 'graph/queries/checklists/get-checklist-query';

export type ChecklistStoreState = {
  checklist?: BenchmarkChecklist | UnitChecklist | WeeklyChecklist;
};

export type ChecklistStoreDispatch = {
  checklistRefetch: any;
};
export type ChecklistStore = [ChecklistStoreState, ChecklistStoreDispatch];

export const getDefaultChecklistStoreState = (): any => ({
  __typename: StoreTypename.CHECKLIST,
});

export const useChecklistStore = (id: number): ChecklistStore => {
  const {
    data,
    refetch: checklistRefetch,
  }: QueryResult<{ checklist: BenchmarkChecklist | UnitChecklist | WeeklyChecklist }> = useQuery(
    GET_CHECKLIST,
    { variables: { where: { id } } as OperationVariables }
  );

  return [
    {
      ...(data && { checklist: data.checklist }),
    },
    {
      checklistRefetch,
    },
  ];
};
